import { render, staticRenderFns } from "./LicitacaoForm.vue?vue&type=template&id=212ea625"
import script from "./LicitacaoForm.vue?vue&type=script&lang=js"
export * from "./LicitacaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports